export default __webpack_public_path__ + "static/media/success.a8c52a4f.svg";